import Swiper from "swiper/bundle";

export default class DesignerDetailsPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initSliders();
  }

  initSliders() {
    const productSwiperDOM = this.dom.querySelector(".products-slider");
    let productSwiper = new Swiper(productSwiperDOM, {
      slidesPerView: 2.5,
      spaceBetween: 20,
      freeMode: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 2,
      },
      breakpoints: {
        1024: {
          slidesPerView: 4.5,
        },
      },
    });

    const designerSwiperDOM = this.dom.querySelector(".designers-slider");
    let designerSwiper = new Swiper(designerSwiperDOM, {
      slidesPerView: 2.5,
      spaceBetween: 20,
      freeMode: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 2,
      },
      breakpoints: {
        1024: {
          slidesPerView: 4.5,
        },
      },
    });
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  resize() {}
}
